const GA4_ENABLED = (process.env.REACT_APP_GA4_ENABLED || "false") === "true";

export function trackEvent(name, params = {}) {
  if (!GA4_ENABLED) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

export function trackPageView(path, extra = {}) {
  if (!GA4_ENABLED) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: path,
    ...extra,
  });
}